import { ComponentProps, JSX } from "react";
import AUSIcon from "../_icons/flags/ausIcon";
import USAIcon from "../_icons/flags/usaIcon";

interface LanguageProps extends ComponentProps<"svg"> {
  locale: string;
};

const LanguageIcon = ({locale, ...props}: LanguageProps) => {
  // add more icons when ready
  const countries: { [key: string]: JSX.Element } = {
    "en-us": <USAIcon {...props}/>,
    "en-au": <AUSIcon {...props}/>
  };
  return countries[locale] || null;
};
export default LanguageIcon;
